// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__34SCk","productName":"Table_productName__2_RPU"};